import type { DropAnimation } from "@dnd-kit/core";
import { defaultDropAnimationSideEffects } from "@dnd-kit/core";

/** Shared ease-out for list shifts and drop settle (visual only). */
export const TASK_DND_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

/** Sortable slot shift — Trello-like ease-out. */
export const TASK_SORTABLE_TRANSITION = {
	duration: 220,
	easing: TASK_DND_EASING,
};

export const TASK_DROP_ANIMATION_MS = 260;

/** Overlay card settling into the list after release. */
export const TASK_DROP_ANIMATION: DropAnimation = {
	duration: TASK_DROP_ANIMATION_MS,
	easing: TASK_DND_EASING,
	sideEffects: defaultDropAnimationSideEffects({
		styles: {
			active: { opacity: "0.42" },
		},
	}),
};
